import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupMessagesByDate',
    // impure: `messages` is mutated in place (push) for live/sent messages rather than
    // reassigned, so a pure pipe would never re-run on the same array reference and new
    // messages would silently fail to render until the next full reload (contact switch).
    pure: false,
    standalone: false
})
export class GroupMessagesByDatePipe implements PipeTransform {
  transform(messages: any[]): any[] {
    if (!messages || !messages.length) return [];

    const result: any[] = [];
    let lastDateKey = '';

    for (const msg of messages) {
      const date = new Date(msg.timestamp);
      const dateKey = date.toDateString();
      if (dateKey !== lastDateKey) {
        result.push({ isDateDivider: true, label: this.formatDateLabel(date) });
        lastDateKey = dateKey;
      }
      result.push(msg);
    }

    return result;
  }

  private formatDateLabel(date: Date): string {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const sameDay = (a: Date, b: Date) =>
      a.getDate() === b.getDate() &&
      a.getMonth() === b.getMonth() &&
      a.getFullYear() === b.getFullYear();

    if (sameDay(date, today)) return 'Today';
    if (sameDay(date, yesterday)) return 'Yesterday';

    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
  }
}
